import NewAssets from './NewAssets';

export default NewAssets;
